import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";

import CancelIcon from "@mui/icons-material/Cancel";
import ItemDateCard from "~business/Cards/ItemDateCard";
import ItemSelectorCard from "~business/Cards/ItemSelectorCard";
import { useSelector, useDispatch } from "react-redux";
import { setMotivoAnulacion } from "../../actions";
import {
  motivoAnulacionFilter,
  motivoAnulacionOptions,
} from "~constants/endosos";
import { Campo, FiltroValue } from "../../../types";
import { OptionKV } from "~styled/selector/Selector";

const title = "Informacion sobre Anulación";

interface DatosAnulacionCardProps {
  isLoading: boolean;
  displayError?: boolean;
  onBlur?: () => void;
}

const useReduxSelector = () =>
  useSelector<any, { motivoAnulacion: FiltroValue }>((state) => ({
    motivoAnulacion:
      state.detallePolizaNuevoReducer.motivoAnulacionSelected.value,
  }));

const DatosAnulacionCard: React.FC<DatosAnulacionCardProps> = ({
  isLoading,
  displayError,
  onBlur,
}) => {
  const { motivoAnulacion } = useReduxSelector();
  const dispatch = useDispatch();

  const handleChangeMotivo = (motivo: Campo<FiltroValue>) => {
    dispatch(setMotivoAnulacion(motivo));
    if (onBlur) onBlur();
  };

  return (
    <DetalleCard title={title} IconHeader={CancelIcon}>
      <ItemDateCard
        readOnly
        isLoading={isLoading}
        label="Fecha Anulación"
        value={new Date()}
      />
      <ItemSelectorCard<FiltroValue>
        isLoading={isLoading}
        label="Motivo Anulación"
        value={motivoAnulacion}
        options={motivoAnulacionFilter as OptionKV<FiltroValue>[]}
        valueOptions={motivoAnulacionOptions}
        onChange={handleChangeMotivo}
        displayError={displayError}
        variant="big"
        required
      />
    </DetalleCard>
  );
};

export default DatosAnulacionCard;
